import script from "./HistorialCitaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HistorialCitaModal.vue?vue&type=script&setup=true&lang=js"

import "./HistorialCitaModal.vue?vue&type=style&index=0&id=f0fd0ef0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0fd0ef0"]])

export default __exports__